<div [formGroup]="specificAmountForm">
  <mat-radio-group
    aria-labelledby="way-to-redeem-radio-group-label"
    class="radio-group-container flex flex-col items-start"
    [formControl]="optionsFormControl">
    <div class="redeem-points-container w-full pt-5">
      <mat-radio-button
        [dataTestid]="'rc-ar-checkout-radio-earliest'"
        class="radio-button px-4 pb-5"
        [value]="autoRedemptionSettingStrategy.EarliestOpportunity">
        <span
          class="whitespace-normal"
          [ngClass]="
            optionSelectedClass(
              autoRedemptionSettingStrategy.EarliestOpportunity
            )
          ">
          {{
            'order.manage.auto_redemption.rc_specific_amount_form.sufficient_balance'
              | translate: { loyaltyProgram: loyaltyProgram.shortName }
          }}
        </span>
      </mat-radio-button>

      <div
        class="flex flex-col self-center"
        [ngClass]="
          optionContentClass(autoRedemptionSettingStrategy.EarliestOpportunity)
        ">
        <div class="mb-7 flex flex-col items-center">
          <div
            class="points-amount-label mt-7 mb-3.5 text-center typo-text-emphasis-1-mobile lg:typo-text-emphasis-1-desktop">
            {{
              'order.manage.auto_redemption.rc_specific_amount_form.loyalty_program_name'
                | translate: { loyaltyProgram: loyaltyProgram.shortName }
            }}
          </div>

          <rd-shared-counter
            formControlName="pointsAmount"
            [config]="pointsAmountCounterConfig"
            [translationsConfig]="pointsAmountCounterTranslationsConfig">
          </rd-shared-counter>
        </div>

        <div
          aria-live="polite"
          class="points-amount-balance-required-container flex flex-col px-11 py-4 lg:flex-row lg:gap-2"
          [innerHTML]="
            'order.manage.auto_redemption.rc_specific_amount_form.points_balance_required'
              | translate
                : {
                    pointsBalanceAmount:
                      pointsBalanceRequired$ | async | localizePointsNumber,
                    loyaltyCurrency: homeLoyaltyCurrency.name
                  }
          "></div>
      </div>
    </div>

    <hr class="m-0 w-full" />

    <div class="redeem-interval-container w-full pt-5">
      <mat-radio-button
        [dataTestid]="'rc-ar-checkout-radio-intervals'"
        class="radio-button mt-1 mb-5 px-4"
        [value]="autoRedemptionSettingStrategy.EveryFewMonths">
        <span
          class="whitespace-normal"
          [ngClass]="
            optionSelectedClass(autoRedemptionSettingStrategy.EveryFewMonths)
          ">
          {{
            'order.manage.auto_redemption.rc_specific_amount_form.regular_intervals'
              | translate: { loyaltyProgram: loyaltyProgram.shortName }
          }}
        </span>
      </mat-radio-button>

      <div
        class="flex flex-col self-center"
        [ngClass]="
          optionContentClass(autoRedemptionSettingStrategy.EveryFewMonths) +
          ' -mt-3'
        ">
        <div class="max-redeem-points-label mb-3.5 pl-11 pr-4">
          {{
            'order.manage.auto_redemption.rc_specific_amount_form.maximum_amount_balance'
              | translate: { loyaltyCurrency: loyaltyProgram.shortName }
          }}
        </div>

        <div
          class="mb-7 flex flex-col justify-between gap-y-7 pl-11 pr-4 sm:flex-row sm:gap-x-6">
          <div class="recurrence w-full">
            <div
              class="mb-3 typo-text-emphasis-1-mobile lg:typo-text-emphasis-1-desktop">
              {{
                'order.manage.auto_redemption.tc_specific_amount_form.recurrence'
                  | translate
              }}
            </div>

            <div class="rd-mat-select relative">
              <mat-select
                formControlName="recurrenceOption"
                class="subject rounded-md h-11 focus-link"
                [placeholder]="
                  'order.manage.auto_redemption.specific_amount_form.placeholder.recurrence_options'
                    | translate
                "
                [disableOptionCentering]="true"
                [hideSingleSelectionIndicator]="true"
                panelClass="recurrence-options-mat-select-panel">
                <mat-option
                  *ngFor="let recurrenceOption of recurrenceOptions"
                  [value]="recurrenceOption.value">
                  <span [innerHTML]="recurrenceOption.name | translate"></span>
                </mat-option>
              </mat-select>

              <rd-shared-icon
                class="icon recurrence-icon pointer-events-none absolute right-3 inline-block h-4"
                [iconSymbol]="'icon-chevron-down'"
                [iconTheme]="'link'">
              </rd-shared-icon>
            </div>
          </div>

          <div class="starting-date w-full">
            <div
              class="mb-3 typo-text-emphasis-1-mobile lg:typo-text-emphasis-1-desktop">
              {{
                'order.manage.auto_redemption.rc_specific_amount_form.starting_date'
                  | translate
              }}
            </div>

            <div class="relative">
              <rd-auto-redemption-date-input
                [dateFormat]="startingDateFormat"
                formControlName="startingDate">
              </rd-auto-redemption-date-input>
            </div>
          </div>
        </div>

        <div
          class="points-amount-balance-required-container flex flex-col gap-3 px-8 py-4">
          <div
            [innerHTML]="
              'order.manage.auto_redemption.rc_specific_amount_form.minimum_points_balance_required'
                | translate
                  : {
                      pointsBalanceAmount:
                        targetTransferRate.minimumTransfer
                        | localizePointsNumber,
                      loyaltyCurrency: homeLoyaltyCurrency.name
                    }
            "></div>

          <div class="flex flex-row items-start gap-2 sm:items-center">
            <rd-shared-icon
              class="icon-increaments py-1"
              [iconSymbol]="'icon-increaments'"
              [iconTheme]="'link'">
            </rd-shared-icon>

            <span
              [innerHTML]="
                'order.manage.auto_redemption.rc_specific_amount_form.happen_in_increment'
                  | translate
                    : {
                        denomination:
                          targetTransferRate.denomination
                          | localizePointsNumber,
                        loyaltyCurrency: homeLoyaltyCurrency.shortName
                      }
              "></span>
          </div>
        </div>
      </div>
    </div>
  </mat-radio-group>
</div>
